import { Helmet } from 'react-helmet-async';
import { SITE } from '../lib/config';
import type { PageDef } from '../lib/config';
import { useEffect } from 'react';
import { trackPageview } from '../lib/analytics';

const OG_IMAGE = `${SITE.domain}/og-image.jpg`;

type SeoProps = {
  page: PageDef;
  schemas?: Record<string, unknown>[];
};

export function Seo({ page, schemas = [] }: SeoProps) {
  const canonical = `${SITE.domain}${page.path}`;
  const robots = page.index ? 'index, follow' : 'noindex, nofollow';

  useEffect(() => {
    trackPageview(page.path);
    if (typeof document !== 'undefined') {
      document.title = page.title;
    }
  }, [page.path, page.title]);

  return (
    <Helmet>
      <meta name="description" content={page.description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Image Enlarger — free AI image upscaler and enlarger online" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content="Image Enlarger — free AI image upscaler and enlarger online" />
      {schemas.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
